import { useContext } from 'react';
import { AccessTokenContext, } from './access-token-context';
export const useAccessToken = () => useContext(AccessTokenContext);
